import Vue from 'vue';
import Router, { Route, RouteConfig } from 'vue-router';
import NProgress from 'nprogress';
import store from '@/store/index';
import util from '@/libs/util';
import menuRoutes from './menus';
import routes, { viewRoutes } from './routes';
import 'nprogress/nprogress.css';

NProgress.configure({ showSpinner: false });
Vue.use(Router);

const router: Router = new Router({
  mode: 'history',
  routes,
});

router.beforeEach((to: Route, from: Route, next: any) => {
  NProgress.start();
  let access = false;
  /* eslint-disable dot-notation */
  if ((store as any).state.user.auth['token']) access = true;
  if (to.path === '/login' && access) next('/');
  else if (to.path === '/login' && !access) next();
  else if (to.path !== 'login' && access) next();
  else next('/login');
});

router.onReady(() => {
  const ROUTES: Array<RouteConfig> = util.getRouter(menuRoutes,
    (store as any).state.user.menuRoutes.map((em :any) => em.path), viewRoutes);
  store.commit('user/SET_USER_MENUS', ROUTES);
  store.commit('user/SET_USER_STAIR_MENUS', viewRoutes);
  router.addRoutes([...ROUTES, ...viewRoutes]);
});

router.afterEach((to: Route, from: Route) => {
  if (to.meta && to.meta.tag) store.dispatch('app/openPage', to);
  NProgress.done();
});

export default router;
